<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Chamado</div>
      </div>
      <div class="card-body mt-4">
        <div class="row mb-4">
          <div class="col-md-1">
            <h5 class="card-title">ID</h5>
            <p class="card-text">#{{ ticket.id }}</p>
          </div>
          <div class="col-md-2">
            <h5 class="card-title">Responsável</h5>
            <p class="card-text">{{ ticket.opened_by.name }}</p>
          </div>
          <div class="col-md-2">
            <h5 class="card-title">Aberto em</h5>
            <p class="card-text">{{ ticket.created_at }}</p>
          </div>
          <div class="col-md-2">
            <h5 class="card-title">Tipo da Reserva</h5>
            <p class="card-text">
              {{
                ticket.reserve_type == 1
                  ? "Sala de Reunião"
                  : "Estação de Trabalho"
              }}
            </p>
          </div>
          <div class="col-md-2">
            <h5 class="card-title">ID da Reserva</h5>
            <p class="card-text">
              <router-link
                v-if="ticket.reserve_type == 1"
                :to="'/schedule_rooms/view/' + ticket.reserve.id"
                >{{ ticket.reserve.id }} <i class="fas fa-external-link-alt"></i
              ></router-link>
              <router-link
                v-else
                :to="'/schedule_workstations/view/' + ticket.reserve.id"
                >{{ ticket.reserve.id }} <i class="fas fa-external-link-alt"></i
              ></router-link>
            </p>
          </div>
          <div class="col-md-3">
            <h5 class="card-title">Assunto</h5>
            <p class="card-text">{{ ticket.subject }}</p>
          </div>
        </div>
        <hr />
        <div class="row mt-4">
          <div class="col-md-8 bdr">
            <div class="row">
              <div class="col-md-12 card-title-bd">Interações</div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <label for>Responder Chamado</label>
                <ckeditor
                  :editor="editor"
                  v-model="new_post"
                  :config="editorConfig"
                ></ckeditor>
              </div>
              <div class="col-md-12 mt-2 mb-4" align="right">
                <router-link class="btn btn-back" to="/tickets"
                  ><i class="fas fa-arrow-left"></i> Voltar</router-link
                >
                <button class="btn btn-add text-right" @click="saveInteraction">
                  Salvar Resposta <i class="fas fa-save ml-1"></i>
                </button>
              </div>
              <div class="col-md-12">
                <div
                  v-for="interaction in ticket.interactions"
                  :key="interaction.id"
                >
                  <div
                    class="container darker text-left"
                    v-if="interaction.order == 1"
                  >
                    <h4 class="card-title text-right">
                      Resposta
                      {{ interaction.user.company.company_name_fantasy }}
                    </h4>
                    <span class="innover-left" style="margin-top: -20px">
                      <i>{{
                        interaction.user
                          ? interaction.user.name
                          : "Não Identificado"
                      }}</i>
                    </span>
                    <br />
                    <span class="time-left ml-1" style="margin-top: -45px">
                      <i>{{ interaction.created_at }}</i>
                    </span>
                    <br />
                    <span v-html="interaction.description"></span>
                  </div>
                  <div
                    class="container"
                    style="background-color: #deebff"
                    v-else-if="interaction.order == '3'"
                  >
                    <h4 class="card-title text-left">Alteração de Status</h4>
                    <span class="time-right" style="margin-top: -30px">
                      {{ interaction.created_at }}
                    </span>
                    <br />
                    <span v-html="interaction.description"></span>
                    <br />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="container" style="background-color: #fff">
                  <h4 class="card-title text-left">Mensagem do Usuário</h4>
                  <br />
                  <span
                    class="ticket-history"
                    v-html="ticket.description"
                  ></span>
                  <br />
                  <span class="time-right">
                    <i>{{ ticket.created_at }}</i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 bdr">
            <div class="row">
              <div class="col-md-12 card-title-bd">Status</div>
              <div class="col-md-12 mt-2" align="center">
                <span v-if="ticket.status == 1" class="badge badge-warning"
                  >Aguardando</span
                >
                <span v-if="ticket.status == 2" class="badge badge-primary"
                  >Em andamento</span
                >
                <span v-if="ticket.status == 3" class="badge badge-success"
                  >Finalizado</span
                >
              </div>
              <div class="col-md-12 mt-3">
                <v-select
                  :options="status"
                  label="text"
                  :reduce="(status) => status.id"
                  placeholder="Selecione o novo status"
                  class="style-chooser"
                  v-model="new_status"
                  v-on:input="changeStatus"
                >
                  <div slot="no-options">Nenhum registro encontrado.</div>
                </v-select>
              </div>
            </div>
            <hr class="mt-4" />
            <div class="row">
              <div class="col-md-12 card-title-bd">Arquivos Anexados</div>
            </div>
            <div class="row mt-3">
              <div
                class="col-md-12"
                v-for="file in ticket.files"
                :key="file.id"
              >
                <div class="alert alert-info" role="alert">
                  <a
                    :href="
                      $store.state.url + '/tickets/file/download/' + file.id
                    "
                    target="_blank"
                  >
                    <strong>{{ file.filename }}</strong>
                    <i class="fas fa-download ml-2"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

class MyUploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  upload() {
    // Update the loader's progress.
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          this._initRequest();
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        })
    );
  }

  // Aborts the upload process.
  abort() {
    // Reject the promise returned from the upload() method.
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());

    // Note that your request may look different. It is up to you and your editor
    // integration to choose the right communication channel. This example uses
    // a POST request with JSON as a data structure but your configuration
    // could be different.
    xhr.open(
      "POST",
      "https://api.projetos.innovareti.com.br/api/v1/images/upload/",
      true
    );
    xhr.responseType = "json";
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    // const genericErrorText = `Couldn't upload file: ${file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      // This example assumes the XHR server's "response" object will come with
      // an "error" which has its own "message" that can be passed to reject()
      // in the upload promise.
      //
      // Your integration may handle upload errors in a different way so make sure
      // it is done properly. The reject() function must be called when the upload fails.
      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }

      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      // This URL will be used to display the image in the content. Learn more in the
      // UploadAdapter#upload documentation.
      resolve({
        default: response.url,
      });
    });

    // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
    // properties which are used e.g. to display the upload progress bar in the editor
    // user interface.
    if (xhr.upload) {
      xhr.upload.addEventListener("progress", (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // Prepare the form data.
    const data = new FormData();

    data.append("upload", file);

    // Important note: This is the right place to implement security mechanisms
    // like authentication and CSRF protection. For instance, you can use
    // XMLHttpRequest.setRequestHeader() to set the request headers containing
    // the CSRF token generated earlier by your application.

    // Send the request.
    this.xhr.send(data);
  }
}

function MyUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = function (loader) {
    return new MyUploadAdapter(loader);
  };
}

export default {
  data: function () {
    return {
      plugins: ["SimpleUploadAdapter"],
      editorConfig: {
        extraPlugins: [MyUploadAdapterPlugin],
        height: "500px",
      },
      editor: ClassicEditor,
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      collapse: 0,
      ticket: {},
      new_post: {},
      additionals: [],
      rooms: [],
      filters: {
        status: [0, 1],
      },
      dataModal: null,
      new_status: "",
      status: [
        {
          id: 1,
          text: "Aguardando",
        },
        {
          id: 2,
          text: "Em andamento",
        },
        {
          id: 3,
          text: "Finalizado",
        },
      ],
      new_post: "",
    };
  },
  components: { vSelect, ClassicEditor },
  methods: {
    saveInteraction() {
      const self = this;
      const api = self.$store.state.api + "tickets/save-interaction";

      self.$http
        .post(api, { id: self.ticket.id, message: self.new_post })
        .then(() => {
          self.getEntity();
          self.$message("Sucesso!", "Resposta salva com sucesso", "success");
          self.new_post = "";
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity() {
      const self = this;
      let id = self.$route.params.id;
      const api =
        self.$store.state.api +
        "tickets/" +
        id +
        "/?with[]=opened_by&with[]=reserve&with[]=files&with[]=interactions";

      self.$http
        .get(api, self.filters)
        .then((response) => {
          self.ticket = response.data.data[0];
          self.$store.commit("updateNotifications");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    collapseToggle() {
      if (this.collapse == 1) {
        this.collapse = 0;
      } else {
        this.collapse = 1;
      }
    },
    changeStatus() {
      const self = this;
      const api = self.$store.state.api + "tickets/change-status";

      self.$http
        .post(api, { id: self.ticket.id, status: self.new_status })
        .then(() => {
          self.getEntity();
          self.$message(
            "Sucesso!",
            "Status do chamado atualizado com sucesso.",
            "success"
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRooms: function () {
      const self = this;
      const api = self.$store.state.api + "rooms?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.rooms = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAdditionals: function () {
      const self = this;
      const api =
        self.$store.state.api + "services_additionals?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.additionals = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getEntity();
    this.getRooms();
    this.getAdditionals();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.badge {
  font-size: 14px;
}
.darker {
  border-color: #ccc;
  background-color: #ddd;
}
.container-fluid,
.container {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
}

.container-fluid::after,
.container::after {
  content: "";
  clear: both;
  display: table;
}

.time-right {
  float: right;
  color: #aaa;
}

.time-left {
  float: left;
  color: #999;
  margin-top: -15px;
}

.text-right {
  text-align: right;
}

.bdr {
  border: 2px #4b2e8f solid;
  margin-left: 35px;
  margin-right: 10px;
  border-radius: 3px;
}

.card-title-bd {
  font-weight: bold;
  font-size: 18px;
  margin-top: 10px;
}
.innover-left {
  color: #999;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/Tickets/Manage.vue